<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eAgdKa/tc-custom/9781426870378.jpg?1718183148593" alt="This image is the cover for the book Bride Wore Blue Jeans"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bride Wore Blue Jeans
      </h1>
      <p class="bookDescription body article font2">
        <p>Between raising his three siblings and running asuccessful business, Kevin Quintano's hectic life left noroom for love. But when his sister announced herupcoming wedding, Kevin headed to Hades, Alaska, toensure she made it down the aisle. Of course, Kevindidn't count on getting bitten by the love bug-or hisown dreamy thoughts of marriage!<br/><br/>AND THEN CAME JUNE!<br/><br/>Even in blue jeans, June Yearling was irresistible but hadrefused every bachelor in town. After a tumultuous past,she swore she'd never surrender her heart. Still, thatdidn't stop her and Kevin from stealing passionate kisseswhenever they could...and it didn't stop his fantasiesabout leading her to the altar.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Ferrarella
      </h2>
      
      <p class="authorDescription body article">This USA TODAY bestselling and RITA &reg; Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?614bad4a